<template>
    <div class="tranvelution">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Tranvelution"></navbar>
        <!--banner-->
        <div class="tranvelution_banner">
            <h1 class="font_big">{{$t('travelution_banner')}}</h1>
            <p class="font_mid">{{$t('travelution_content')}}</p>
            <p class="font_mid">{{$t('travelution_content1')}}</p>
        </div>
        <!--about ifreegroup-->
        <div class="tranvelution_about_ifree">
            <div class="tranvelution_about_ifree_wrap">
                <h1 class="font_big">{{$t('travelution_about_us')}}</h1>
                <div class="tranvelution_about_ifree_content">
                    <p class="font_mid">
                        <br>{{$t('travelution_about_us_content')}}<br>
                        <br>{{$t('travelution_about_us_content_right')}}
                    </p>
                    <p class="font_mid">
                        <br>{{$t('travelution_about_us_content1')}}
                    </p>
                    <div style="clear: both"></div>
                </div>
            </div>
        </div>
        <div style="clear: both"></div>
        <div class="tranvelution_content">
            <div class="tranvelution_content_wrap">
                <h1 class="font_big">{{$t('travelution_system')}}</h1>
                <div class="tranvelution_about_ifree_content">
                    <p class="font_mid">{{$t('travelution_system_tittle')}}</p>
                    <p class="font_mid">{{$t('travelution_system_tittle1')}}</p>
                </div>
                <div style="clear: both;"></div>
                <div class="tranvelution_content_system">
                    <Row>
                        <i-col :lg="12" :md="12" :sm="24" :xs="24">
                            <img class="system_img" src="../../assets/about_us/system_tc@2x.png" v-if="this.lang == 'tc' "/>
                            <img class="system_img" src="../../assets/about_us/system_sc@2x.png" v-else-if="this.lang == 'sc' "/>
                            <img class="system_img" src="../../assets/about_us/system_en@2x.png" v-else-if="this.lang == 'en' "/>
                        </i-col>
                        <i-col :lg="12" :md="12" :sm="24" :xs="24">
                            <i-col :xs="24" :sm="24" :md="24" :lg="24">
                                <div :current="current" direction="vertical" class="steps-1">
                                    <a class="font_mid tab_title" v-for="(item,index) in tabs"
                                       :class="{active:index == num}"
                                       @click="tab(index)" style="color: #99A9BF;">
                                        <img :src="item.Showtitle" v-if="index == num">
                                        <img :src="item.title" v-else>
                                    </a>
                                </div>
                            </i-col>
                            <i-col :span="24" style="height: 480px">
                                <div class="tabCon"  v-for='(itemCon,index) in tabContents'>
                                    <div class="about-ifree-system-tabcon" v-show=" index == num" :key="index">
                                        <div class="about-ifree-system-group">
                                            <h1>{{itemCon.name}}</h1>
                                            <p>{{itemCon.description}}</p>
                                        </div>
                                    </div>
                                </div>
                            </i-col>
                        </i-col>
                    </Row>
                </div>
            </div>
        </div>
        <div class="travelution_ours">
            <div class="travelution_ours_wrap">
                <Row>
                    <i-col :lg="12" :md="12" :sm="24" :xs="24">
                        <img src="../../assets/home/new_home/vision_pic@2x.jpg">
                    </i-col>
                    <i-col :lg="12" :md="12" :sm="24" :xs="24">
                        <h1 class="font_big">{{$t('travelution_vision')}}</h1>
                        <p class="font_mid">{{$t('travelution_vision_content')}}</p>
                    </i-col>
                </Row>
            </div>
        </div>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>
<script>
    import navbar from '../Common/Navbar.vue'
    export default {
        data () {
            return {
                isTransparent: false,
                lang:'tc',
                current: 0,
                tabs: [
                    {
                        title: require('../../assets/home/new_home/ic_iot product_normal@2x.png'),
                        Showtitle: require('../../assets/home/new_home/ic_iot product_selected@2x.png')
                    },
                    {
                        title: require('../../assets/home/new_home/ic_iretail_no_selected@2x.png'),
                        Showtitle: require('../../assets/home/new_home/ic_iretail_selected@2x.png')
                    },
                    {
                        title: require('../../assets/home/new_home/ic_security_normal@2x.png'),
                        Showtitle: require('../../assets/home/new_home/ic_security_selected@2x.png')
                    },
                    {
                        title: require('../../assets/home/new_home/ic_Insurance_normal@2x.png'),
                        Showtitle: require('../../assets/home/new_home/ic_Insurance_selected@2x.png')
                    },
                    {
                        title: require('../../assets/home/new_home/ic_booking_normal@2x.png'),
                        Showtitle: require('../../assets/home/new_home/ic_booking_selected@2x.png')
                    },
                    {
                        title: require('../../assets/home/new_home/ic_message_normal@2x.png'),
                        Showtitle: require('../../assets/home/new_home/ic_message_selected@2x.png')
                    },
                    {
                        title: require('../../assets/home/new_home/ic_global iretail_normal@2x.png'),
                        Showtitle: require('../../assets/home/new_home/ic_global iretail_selected@2x.png')
                    }
                ],
                tabContents: [
                    {
                        name:  this.$t('travelution_name1'),
                        description: this.$t('travelution_system1')
                    },
                    {
                        name:  this.$t('travelution_name2'),
                        description: this.$t('travelution_system2')
                    },
                    {
                        name:  this.$t('travelution_name3'),
                        description: this.$t('travelution_system3')
                    },
                    {
                        name:  this.$t('travelution_name4'),
                        description: this.$t('travelution_system4')
                    },
                    {
                        name:  this.$t('travelution_name5'),
                        description: this.$t('travelution_system5')
                    },
                    {
                        name:  this.$t('travelution_name6'),
                        description: this.$t('travelution_system6')
                    },
                    {
                        name:  this.$t('travelution_name7'),
                        description: this.$t('travelution_system7')
                    }
                ],
                num: 0
            }
        },
        components: {
            navbar
        },
        methods: {
            //自动轮播
            autoPlay () {
                this.num++;
                if (this.num === 7) {
                    this.num = 0
                }
            },
            //添加一个计时器
            play () {
                setInterval(this.autoPlay, 8000)
            },
            //点击切换
            tab (index) {
                this.num = index
                this.current = index
            }
        },
        created () {
            //自动轮播
            this.play()
            //判断语言包
            let lang = this.$i18n.locale
            if (lang == 'en-US'){
                this.lang = 'en'
            }else if (lang == 'zh-HK'){
                this.lang = 'tc'
            }else if (lang == 'zh-CN'){
                this.lang = 'sc'
            }
        }
    }
</script>
<style lang="scss">
    @import "../../scss/_tranvelution.scss";

</style>



// WEBPACK FOOTER //
// Tranvelution.vue?5bac8c4a